import React from 'react';
import * as icons from './icons';

export function IconsPreview() {
    console.log('icons', icons);

    return (
        <div>
            {Object.keys(icons).map((key) => (
                <div
                    key={key}
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '12px',
                        marginLeft: '30px',
                        marginBottom: '12px',
                    }}
                >
                    {React.createElement(icons[key], { size: 46 })}
                    <div>{key}</div>
                </div>
            ))}
        </div>
    );
}
